<form *ngIf="data" class="u-padding-30" autocomplete="off" [formGroup]="testForm">
  <div>
    <div class="mt-3 u-margin-bottom-50">
      <div mat-dialog-title *ngIf="data.isPPD" class="u-font-weight-400 general-info--font-size-35">Add Power-Performance Decoder</div>
      <div mat-dialog-title *ngIf="data.isManual" class="u-font-weight-400 general-info--font-size-35">Add Manual Test</div>
      <div mat-dialog-title *ngIf="data.isVirtual" class="u-font-weight-400 general-info--font-size-35">Add Virtual Test</div>
      <div mat-dialog-title *ngIf="data.isLactate" class="u-font-weight-400 general-info--font-size-35">{{!back ? 'Add Lactate test' : 'Edit Lactate Test'}}</div>
    </div>

    <ng-container *ngIf="!(isOnboardingComplete$ | async)">
      <app-custom-back-button></app-custom-back-button>
      <!-- <app-progress-bar [value$]="onboardingProgress" label="Onboarding Progress"></app-progress-bar> -->
    </ng-container>
    <h3 class="sub-title">Basic Information</h3>
    <div>
      <div class="form-group row">
        <div class="field-col">
          <mat-form-field class="full-width" appearance="outline" floatLabel="always">
            <mat-label>Athlete</mat-label>
            <mat-select placeholder="Select an athlete" formControlName="athlete" (selectionChange)="onChangeAthlete($event.value)">
              <mat-option>
                <ngx-mat-select-search [formControl]="searchAthleteCtrl"
                                       placeholderLabel="Search Athletes"
                                       noEntriesFoundLabel="no matching athletes found"></ngx-mat-select-search>
              </mat-option>
              <mat-option (click)="openModalWindowCreateNewAthlete()">
                <span class="u-color-red-light">Create New Athlete</span>
              </mat-option>
              <mat-option *ngFor="let athlete of athletes"
                          [value]="athlete?.id">
                {{ athlete?.first_name }} {{ athlete?.last_name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="
                  testForm.controls?.athlete?.errors &&
                  testForm.controls?.athlete?.touched">
              <div [innerHTML]="testForm.controls.athlete.errors| errorFormFormat : { fieldName: 'Athlete'}"></div>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="field-col">
          <mat-form-field class="full-width"
                          appearance="outline"
                          floatLabel="always">
            <mat-label>Sport</mat-label>
            <mat-select placeholder="Select a sport"
                        formControlName="sport"
                        (selectionChange)="onChangeSport($event.value)">
              <mat-option *ngFor="let sport of allSports" [value]="sport?.id">
                {{ sport?.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="
                  testForm.controls?.sport?.errors &&
                  testForm.controls?.sport?.touched">
              <div [innerHTML]="
                    testForm.controls.sport.errors
                      | errorFormFormat : { fieldName: 'Sport' }"></div>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="field-col">
          <mat-form-field class="full-width" appearance="outline" floatLabel="always">
            <mat-label>Date</mat-label>
            <input matInput formControlName="test_date" [matDatepicker]="picker" (click)="picker.open()"/>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="testForm.controls?.test_date?.errors &&testForm.controls?.test_date?.touched">
              <div [innerHTML]="testForm.controls.test_date.errors | errorFormFormat : { fieldName: 'Test date' }"></div></mat-error>
          </mat-form-field>
        </div>
        <div class="field-col">
          <mat-form-field class="full-width" appearance="outline" floatLabel="always">
            <mat-label>Coach</mat-label>
            <mat-select placeholder="Select a coach" formControlName="coach">
              <mat-option *ngFor="let coach of coaches" [value]="coach?.id">
                {{ coach?.username }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="testForm.controls?.coach?.errors && testForm.controls?.coach?.touched">
              <div [innerHTML]="testForm.controls.coach.errors | errorFormFormat : { fieldName: 'Coach' }"></div>
            </mat-error>
          </mat-form-field>
        </div>

        <div>
          <ng-container *ngIf="data.isPPD || data.isLactate">
            <h3 class="sub-title">Raw Test Data Upload</h3>
          </ng-container>
          <div class="setting__section" *ngIf="data.isPPD">
            <div class="content">
              <div class="field" *ngIf="data.isPPD">
                <app-chips [label]="'Files'"
                           [form]="testForm.get('files')"
                           [options]="filteredTests"
                           [displayField]="'name'"
                           (optionChange)="onSelectFile($event)"></app-chips>
              </div>
              <div class="file-upload-section border-color drop-file-background" appDragFile (files)="filesDropped($event)">
                <div class="text-wrapper">
                  <input type="file" #fileUpload hidden multiple (change)="changeFile($event)"/>
                  <div class="u-font-weight-500 u-font-size-14 faded-text-color">Drop files here, or</div>
                  <div (click)="fileUpload.click()" class="u-font-weight-500 u-font-size-14 primary-color u-cursor-pointer u-margin-left-5 u-text-underline">Choose File</div>
                </div>
                <div class="u-font-weight-400 u-font-size-13 no-file-chosen-color u-text-align-center">No file choosen yet</div>
              </div>
            </div>
          </div>
          <div class="setting__section" *ngIf="data.isLactate">
            <div class="file-upload-section border-color drop-file-background" appDragFile (files)="handleDragFileInput($event)">
              <div class="text-wrapper">
                <input #fileLactateUpload hidden type="file" id="file" (change)="handleFileInput($event)" />
                <div class="u-font-weight-500 u-font-size-14 faded-text-color">Drop files here, or</div>
                <div (click)="fileLactateUpload.click()" class="u-font-weight-500 u-font-size-14 primary-color u-cursor-pointer u-margin-left-5 u-text-underline">Choose File</div>
              </div>
              <div *ngIf="!fileToUpload" class="u-font-weight-400 u-font-size-13 no-file-chosen-color u-text-align-center">No file choosen yet</div>
              <div *ngIf="fileToUpload" class="u-font-weight-400 u-font-size-13 no-file-chosen-color u-text-align-center">{{fileToUpload.name}}</div>
            </div>
          </div>
          <div class="setting__section"
               *ngIf="data.isManual || data.isVirtual">
            <h3 class="sub-title">Metabolic Capacities</h3>
            <div class="content">
              <div class="field-col">
                <mat-form-field class="full-width"
                                appearance="outline"
                                floatLabel="always">
                  <mat-label>VO2max</mat-label>
                  <input matInput
                         type="number"
                         formControlName="vo2max_min"
                         [required]="data.isManual"/>
                  <span matSuffix>ml/min/kg body mass</span>
                  <mat-error *ngIf="
                    testForm.controls?.vo2max_min?.errors &&
                    testForm.controls?.vo2max_min?.touched">
                    <div [innerHTML]="
                      testForm.controls.vo2max_min.errors
                        | errorFormFormat : { fieldName: 'VO2max', min: 1, max: 150 }"></div>
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="field-col">
                <mat-form-field class="full-width"
                                appearance="outline"
                                floatLabel="always">
                  <mat-label>VLamax</mat-label>
                  <input matInput
                         type="number"
                         formControlName="vlamax"
                         [required]="data.isManual"/>
                  <span matSuffix>mmol/l/s</span>
                  <mat-error *ngIf="
                    testForm.controls?.vlamax?.errors &&
                    testForm.controls?.vlamax?.touched">
                    <div [innerHTML]="
                      testForm.controls.vlamax.errors
                        | errorFormFormat : { fieldName: 'VLamax', min: 0, max: 3 }"></div>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="u-margin-top-30">
          <h3 class="sub-title">Body composition</h3>

          <div class="field-col">
            <mat-form-field class="full-width" appearance="outline" floatLabel="always">
              <mat-label>Weight</mat-label>
              <input data-component="add-ppd-lactate-test-weight" type="number" matInput formControlName="mass" />
              <span matSuffix>kg</span>
              <mat-error *ngIf="testForm.controls?.mass?.errors && testForm.controls?.mass?.touched">
                <div [innerHTML]="testForm.controls.mass.errors| errorFormFormat : { fieldName: 'Weight', min: 10, max: 200 }"></div></mat-error>
            </mat-form-field>
          </div>

          <div class="field-col">
            <mat-form-field class="full-width" appearance="outline" floatLabel="always">
              <mat-label>Height</mat-label>
              <input matInput type="number" formControlName="height" />
              <span matSuffix>cm</span>
              <mat-error *ngIf="testForm.controls?.height?.errors && testForm.controls?.height?.touched">
                <div [innerHTML]="testForm.controls.height.errors | errorFormFormat : { fieldName: 'Height', min:  100, max: 300}"></div></mat-error>
            </mat-form-field>
          </div>

          <div class="field-col">
            <mat-form-field class="full-width" appearance="outline" floatLabel="always">
              <mat-label>Body Fat %</mat-label>
              <input matInput type="number" formControlName="proz_body_fat_100"/>
              <span matSuffix>% of body mass</span>
              <mat-error *ngIf="testForm.controls?.proz_body_fat_100?.errors && testForm.controls?.proz_body_fat_100?.touched">
                <div [innerHTML]="testForm.controls.proz_body_fat_100.errors | errorFormFormat : { fieldName: 'Fat %', min: 3, max: 40 }"></div></mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="u-margin-right-10">
          <div class="setting__section">
            <h3 class="sub-title">
              <mat-icon *ngIf="!isShowAdvancedSetting" (click)="isShowAdvancedSetting = true">keyboard_arrow_right</mat-icon>
              <mat-icon *ngIf="isShowAdvancedSetting" (click)="isShowAdvancedSetting = false">keyboard_arrow_down</mat-icon>
              Advanced Body Composition
            </h3>
            <div class="content" *ngIf="isShowAdvancedSetting">
              <section class="mt-3 mb-3 ml-3">
                <mat-checkbox color="primary" (change)="showOptions($event)" formControlName="auto_calc_body_com">
                  Automatic Body Composition Calculation</mat-checkbox>
              </section>
              <div class="field-col" *ngIf="!isChecked">
                <mat-form-field class="full-width" appearance="outline" floatLabel="always">
                  <mat-label>Body Water</mat-label>
                  <input [readonly]="isChecked" matInput type="number" formControlName="proz_body_water_100_override"/>
                  <span matSuffix>% of body mass</span>
                  <mat-error *ngIf="testForm.controls?.proz_body_water_100_override?.errors && testForm.controls?.proz_body_water_100_override?.touched">
                    <div [innerHTML]="testForm.controls.proz_body_water_100_override.errors| errorFormFormat : { fieldName: 'Body water' }"></div></mat-error>
                </mat-form-field>
              </div>
              <div class="field-col" *ngIf="isChecked">
                <mat-form-field class="full-width" appearance="outline" floatLabel="always">
                  <mat-label>Body Water</mat-label>
                  <input matInput [readonly]="isChecked" value="automatic" />
                  <span matSuffix>% of body mass</span>
                </mat-form-field>
              </div>
              <div class="field-col" *ngIf="!isChecked">
                <mat-form-field class="full-width" appearance="outline" floatLabel="always">
                  <mat-label>Body Muscle</mat-label>
                  <input [readonly]="isChecked" matInput type="number" formControlName="proz_body_muscle_100_override"/>
                  <span matSuffix>% of body mass</span>
                  <mat-error *ngIf="testForm.controls?.proz_body_muscle_100_override ?.errors && testForm.controls?.proz_body_muscle_100_override?.touched">
                    <div [innerHTML]="testForm.controls.proz_body_muscle_100_override.errors | errorFormFormat : { fieldName: 'Body muscle' }"></div>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="field-col" *ngIf="isChecked">
                <mat-form-field class="full-width" appearance="outline" floatLabel="always">
                  <mat-label>Body Muscle</mat-label>
                  <input matInput [readonly]="isChecked" value="automatic" />
                  <span matSuffix>% of body mass</span>
                </mat-form-field>
              </div>
              <div class="field-col" *ngIf="!isChecked">
                <mat-form-field class="full-width" appearance="outline" floatLabel="always">
                  <mat-label>Muscle Mass Used</mat-label>
                  <input matInput
                         type="number"
                         [readonly]="isChecked"
                         formControlName="proz_muscle_mass_used_100_override"/>
                  <span matSuffix>% of muscle mass</span>
                  <mat-error *ngIf="
                      testForm.controls?.proz_muscle_mass_used_100_override
                        ?.errors &&
                      testForm.controls?.proz_muscle_mass_used_100_override?.touched">
                    <div [innerHTML]="
                        testForm.controls.proz_muscle_mass_used_100_override.errors | errorFormFormat : { fieldName: 'Muscle Mass Used' }"></div>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="field-col" *ngIf="isChecked">
                <mat-form-field class="full-width" appearance="outline" floatLabel="always">
                  <mat-label>Muscle Mass Used</mat-label>
                  <input matInput [readonly]="isChecked" value="automatic" />
                  <span matSuffix>% of muscle mass</span>
                </mat-form-field>
              </div>
              <div class="field-col" *ngIf="!isChecked">
                <mat-form-field class="full-width" appearance="outline" floatLabel="always">
                  <mat-label>Glycogen Content</mat-label>
                  <input matInput type="number" [readonly]="isChecked" formControlName="glycogen_content"/>
                  <span matSuffix>g/kg MM</span>
                  <mat-error *ngIf="testForm.controls?.glycogen_content?.errors && testForm.controls?.glycogen_content?.touched">
                    <div [innerHTML]="testForm.controls.glycogen_content.errors | errorFormFormat : { fieldName: 'Glycogen Content', min: 13, max: 28 }"></div>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="field-col" *ngIf="isChecked">
                <mat-form-field class="full-width" appearance="outline" floatLabel="always">
                  <mat-label>Glycogen Content</mat-label>
                  <input matInput [readonly]="isChecked" value="automatic" />
                  <span matSuffix>g/kg MM</span>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <div class="u-margin-right-10" *ngIf="showEquipment">
          <div class="setting__section">
            <h3 class="sub-title">
              <mat-icon *ngIf="!isShowEquipmentUsedSetting" (click)="isShowEquipmentUsedSetting = true">keyboard_arrow_right</mat-icon>
              <mat-icon *ngIf="isShowEquipmentUsedSetting" (click)="isShowEquipmentUsedSetting = false">keyboard_arrow_down</mat-icon>
              Equipment Used
            </h3>
            <div class="content" *ngIf="isShowEquipmentUsedSetting">
              <div class="o-flex o-flex--justify-center o-flex--wrap">
                <app-test-equipment
                  class="u-margin-right-10 u-margin-bottom-10"
                  *ngFor="let item of testEquipmentTileList"
                  (onChange)="onChangeEquipment($event)"
                  [equipmentDeviceList]="originalDeviceList"
                  [config]="item"
                  [context]="testCreationType"
                  [isExpanded]="true"
                ></app-test-equipment>
              </div>
              <!-- TODO: These need to be per category I think -->
              <!-- <div class="o-flex o-flex--column">
                <mat-checkbox *ngIf="rights.admin_org_update" color="primary" formControlName="is_default_organization" class="u-margin-bottom-4">
                  <span class="u-font-size-14 u-font-weight-500">Save as default for my organization</span>
                </mat-checkbox>
                <mat-checkbox *ngIf="rights.athletes_update" color="primary" formControlName="is_default_athlete" class="u-margin-bottom-4">
                  <span class="u-font-size-14 u-font-weight-500">Save as default for this athlete</span>
                </mat-checkbox>
              </div> -->
            </div>
          </div>
        </div>

        <div class="u-margin-right-10">
          <div class="setting__section">
            <h3 class="sub-title">
              <mat-icon *ngIf="!isShowDocumentationAndEnvironment" (click)="isShowDocumentationAndEnvironment = true">keyboard_arrow_right</mat-icon>
              <mat-icon *ngIf="isShowDocumentationAndEnvironment" (click)="isShowDocumentationAndEnvironment = false">keyboard_arrow_down</mat-icon>
              Documentation of Test Environment and Comments
            </h3>
            <div class="content" *ngIf="isShowDocumentationAndEnvironment">
              <div class="field-col">
                <mat-form-field class="full-width" appearance="outline" floatLabel="always">
                  <mat-label>Location</mat-label>
                  <input matInput formControlName="location" />
                </mat-form-field>
              </div>

              <mat-checkbox color="primary" class="virtualCheckBox" *ngIf="data.isManual">Virtual</mat-checkbox>
              <div class="field">
                <app-chips *ngIf="backTestDataLoaded && initDataLoaded"
                           class="u-margin-left-4"
                           [label]="'Tags'"
                           [form]="testForm.get('tags')"
                           [options]="allTags"
                           [displayField]="'name'"
                           [autocompleteType]="autocompleteTagsEnum.TAGS"
                           (optionChange)="onSelectTag($event)"
                           (selectNewTag)="onSelectNewTag($event)"
                           (removeNewTag)="onRemoveNewTag($event)"></app-chips>
                <mat-error *ngIf="testForm.controls?.tags?.errors && testForm.controls?.tags?.touched">
                  <div>{{testForm.controls.tags.errors?.errorTags}}</div>
                </mat-error>
              </div>

              <div class="field-col">
                <mat-form-field class="full-width" appearance="outline" floatLabel="always">
                  <mat-label>Comment</mat-label>
                  <textarea placeholder="Write something ..." rows="5" matInput formControlName="comment"></textarea>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <div class="setting__section">
          <h3 class="sub-title">
            <mat-icon *ngIf="!isShowExpertSetting" (click)="isShowExpertSetting = true">keyboard_arrow_right</mat-icon>
            <mat-icon *ngIf="isShowExpertSetting" (click)="isShowExpertSetting = false">keyboard_arrow_down</mat-icon>
            Expert Settings
          </h3>
          <div class="content" *ngIf="isShowExpertSetting">
            <div class="content"
                 *ngIf="isShowExpertSetting">
              <p style="margin-top: 2%">Energy demand Equation (EDE)</p>
              <p class="subheading">Test specific EDE Values</p>
              <div class="group u-margin-bottom-8">
                <div class="field-small">
                  <mat-form-field class="full-width"
                                  appearance="outline"
                                  floatLabel="always">
                    <mat-label>A (constant)</mat-label>
                    <input matInput
                           type="number"
                           formControlName="au_override"
                           placeholder="Override value"/>
                    <mat-error *ngIf="
                      testForm.controls?.au_override?.errors &&
                      testForm.controls?.au_override?.touched">
                      <div [innerHTML]="
                        testForm.controls.au_override.errors
                          | errorFormFormat
                            : { fieldName: 'Energy demand equation: term A', min: -1, max: 20 }"></div>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="field-small">
                  <mat-form-field class="full-width"
                                  appearance="outline"
                                  floatLabel="always">
                    <mat-label>term B (linear)</mat-label>
                    <input matInput
                           type="number"
                           formControlName="bu_override"
                           placeholder="Override value"/>
                    <mat-error *ngIf="
                      testForm.controls?.bu_override?.errors &&
                      testForm.controls?.bu_override?.touched">
                      <div [innerHTML]="
                        testForm.controls.bu_override.errors
                          | errorFormFormat
                            : { fieldName: 'Energy demand equation: term B' }"></div>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="field-small">
                  <mat-form-field class="full-width"
                                  appearance="outline"
                                  floatLabel="always">
                    <mat-label>D (cubic)</mat-label>
                    <input matInput
                           type="number"
                           formControlName="du_override"
                           placeholder="Override value"/>
                    <mat-error *ngIf="
                      testForm.controls?.du_override?.errors &&
                      testForm.controls?.du_override?.touched">
                      <div [innerHTML]="
                        testForm.controls.du_override.errors
                          | errorFormFormat
                            : { fieldName: 'Energy demand equation: term D' }"></div>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <p *ngIf="data.isVirtual" class="subheading">Used Values</p>
              <div *ngIf="data.isVirtual" class="group" style="margin-bottom: 2%">
                <div class="field-small">
                  <mat-form-field
                    class="full-width"
                    appearance="outline"
                    floatLabel="always"
                  >
                    <mat-label>A (constant)</mat-label>
                    <input
                      matInput
                      type="number"
                      [readonly]="true"
                      value="{{ this.testForm.get('au_override')?.value }}"
                      matTooltip="If empty, default value will be used."
                    />
                  </mat-form-field>
                </div>
                <div class="field-small">
                  <mat-form-field
                    class="full-width"
                    appearance="outline"
                    floatLabel="always"
                  >
                    <mat-label>term B (linear)</mat-label>
                    <input
                      matInput
                      type="number"
                      [readonly]="true"
                      value="{{ this.testForm.get('bu_override')?.value }}"
                      matTooltip="If empty, default value will be used."
                    />
                  </mat-form-field>
                </div>
                <div class="field-small">
                  <mat-form-field
                    class="full-width"
                    appearance="outline"
                    floatLabel="always"
                  >
                    <mat-label>D (cubic)</mat-label>
                    <input
                      matInput
                      type="number"
                      [readonly]="true"
                      value="{{ this.testForm.get('du_override')?.value }}"
                      matTooltip="If empty, default value will be used."
                    />
                  </mat-form-field>
                </div>
              </div>
              <p class="subheading" style="margin-top: -2%">Default EDE Values</p>
              <div class="group">
                <div class="field-small">
                  <mat-form-field
                    class="full-width"
                    appearance="outline"
                    floatLabel="always"
                  >
                    <mat-label>A (constant)</mat-label>
                    <input
                      matInput
                      [readonly]="true"
                      value="automatic"
                    />
                  </mat-form-field>
                </div>
                <div class="field-small">
                  <mat-form-field
                    class="full-width"
                    appearance="outline"
                    floatLabel="always"
                  >
                    <mat-label>B (linear)</mat-label>
                    <input
                      matInput
                      [readonly]="true"
                      value="automatic"
                    />
                  </mat-form-field>
                </div>
                <div class="field-small">
                  <mat-form-field
                    class="full-width"
                    appearance="outline"
                    floatLabel="always"
                  >
                    <mat-label>D (cubic)</mat-label>
                    <input
                      matInput                      
                      [readonly]="true"
                      value="automatic"
                    />
                  </mat-form-field>
                </div>
              </div>

              <p style="margin-top: 2%">O2 per Watt Equation</p>
              <p class="subheading">Test specific values</p>
              <div class="group">
                <div class="field-small">
                  <mat-form-field
                    class="full-width"
                    appearance="outline"
                    floatLabel="always"
                  >
                    <mat-label>A (constant)</mat-label>
                    <input
                      matInput
                      type="number"
                      formControlName="o2_per_watt_eq_a"
                      placeholder="Override value"
                    />
                    <mat-error
                      *ngIf="
                      testForm.controls?.o2_per_watt_eq_a?.errors &&
                      testForm.controls?.o2_per_watt_eq_a?.touched
                    "
                    >
                      <div
                        [innerHTML]="
                        testForm.controls.o2_per_watt_eq_a.errors
                          | errorFormFormat : { fieldName: 'O2 per watt EQ A' }
                      "
                      ></div>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="field-small">
                  <mat-form-field
                    class="full-width"
                    appearance="outline"
                    floatLabel="always"
                  >
                    <mat-label>B (linear)</mat-label>
                    <input
                      matInput
                      type="number"
                      formControlName="o2_per_watt_eq_b"
                      placeholder="Override value"
                    />
                    <mat-error
                      *ngIf="
                      testForm.controls?.o2_per_watt_eq_b?.errors &&
                      testForm.controls?.o2_per_watt_eq_b?.touched
                    "
                    >
                      <div
                        [innerHTML]="
                        testForm.controls.o2_per_watt_eq_b.errors
                          | errorFormFormat : { fieldName: 'O2 per watt EQ B' }
                      "
                      ></div>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="field-small">
                  <mat-form-field
                    class="full-width"
                    appearance="outline"
                    floatLabel="always"
                  >
                    <mat-label>D (cubic)</mat-label>
                    <input
                      matInput
                      type="number"
                      formControlName="o2_per_watt_eq_d"
                      placeholder="Override value"
                    />
                    <mat-error
                      *ngIf="
                      testForm.controls?.o2_per_watt_eq_d?.errors &&
                      testForm.controls?.o2_per_watt_eq_d?.touched
                    "
                    >
                      <div
                        [innerHTML]="
                        testForm.controls.o2_per_watt_eq_d.errors
                          | errorFormFormat : { fieldName: 'O2 per watt EQ D' }
                      "
                      ></div>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="field-col">
                <mat-form-field
                  class="full-width"
                  appearance="outline"
                  floatLabel="always"
                >
                  <mat-label>O2 constant term</mat-label>
                  <input matInput type="number" [readonly]="true" value="16" />
                </mat-form-field>
              </div>

              <p *ngIf="data.isVirtual" class="subheading">Used values</p>
              <div *ngIf="data.isVirtual" class="group">
                <div class="field-small">
                  <mat-form-field
                    class="full-width"
                    appearance="outline"
                    floatLabel="always"
                  >
                    <mat-label>A (constant)</mat-label>
                    <input
                      matInput
                      type="number"
                      [readonly]="true"
                      value="{{ this.testForm.get('o2_per_watt_eq_a')?.value }}"
                      matTooltip="If empty, default value will be used."
                    />
                  </mat-form-field>
                </div>
                <div class="field-small">
                  <mat-form-field
                    class="full-width"
                    appearance="outline"
                    floatLabel="always"
                  >
                    <mat-label>B (linear)</mat-label>
                    <input
                      matInput
                      type="number"
                      [readonly]="true"
                      value="{{ this.testForm.get('o2_per_watt_eq_b')?.value }}"
                      matTooltip="If empty, default value will be used."
                    />
                  </mat-form-field>
                </div>
                <div class="field-small">
                  <mat-form-field
                    class="full-width"
                    appearance="outline"
                    floatLabel="always"
                  >
                    <mat-label>D (cubic)</mat-label>
                    <input
                      matInput
                      type="number"
                      [readonly]="true"
                      value="{{ this.testForm.get('o2_per_watt_eq_d')?.value }}"
                      matTooltip="If empty, default value will be used."
                    />
                  </mat-form-field>
                </div>
              </div>

              <div *ngIf="data.isVirtual" class="field-col">
                <mat-form-field
                  class="full-width"
                  appearance="outline"
                  floatLabel="always"
                >
                  <mat-label>O2 constant term</mat-label>
                  <input
                    matInput
                    type="number"
                    [readonly]="true"
                    value="16"
                    matTooltip="If empty, default value will be used."
                  />
                </mat-form-field>
              </div>

              <p class="subheading" style="margin-top: 0%">Default values</p>
              <div class="group">
                <div class="field-small">
                  <mat-form-field
                    class="full-width"
                    appearance="outline"
                    floatLabel="always"
                  >
                    <mat-label>A (constant)</mat-label>
                    <input
                      matInput
                      [readonly]="true"
                      value="automatic"
                    />
                  </mat-form-field>
                </div>
                <div class="field-small">
                  <mat-form-field
                    class="full-width"
                    appearance="outline"
                    floatLabel="always"
                  >
                    <mat-label>B (linear)</mat-label>
                    <input
                      matInput
                      [readonly]="true"
                      value="automatic"
                    />
                  </mat-form-field>
                </div>
                <div class="field-small">
                  <mat-form-field
                    class="full-width"
                    appearance="outline"
                    floatLabel="always"
                  >
                    <mat-label>D (cubic)</mat-label>
                    <input
                      matInput
                      [readonly]="true"
                      value="automatic"
                    />
                  </mat-form-field>
                </div>
              </div>

              <div class="field-col" style="margin-bottom: 4%">
                <mat-form-field
                  class="full-width"
                  appearance="outline"
                  floatLabel="always"
                >
                  <mat-label>O2 constant term</mat-label>
                  <input 
                      matInput
                      [readonly]="true"
                      value="automatic"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <div class="setting__section" [formGroup]="formConditions">
          <h3 class="sub-title">
            <mat-icon *ngIf="!isShowEnergySetting" (click)="isShowEnergySetting = true">keyboard_arrow_right</mat-icon>
            <mat-icon *ngIf="isShowEnergySetting" (click)="isShowEnergySetting = false">keyboard_arrow_down</mat-icon>
            Energy Demand Conditions
          </h3>
          <div class="content" *ngIf="isShowEnergySetting">
            <div
              formArrayName="conditions"
              *ngFor="let condition of conditions.controls; let i = index"
            >
              <ng-container [formGroupName]="i">
                <div class="field-col">
                  <button
                    type="button"
                    mat-raised-button
                    color="warn"
                    class="remove-btn"
                    (click)="removeCondition(i)"
                  >
                    X
                  </button>
                  <mat-form-field
                    class="full-width"
                    appearance="outline"
                    floatLabel="always"
                  >
                    <mat-label>Condition {{ i + 1 }}</mat-label>
                    <input matInput formControlName="name" [readonly]="condition.get('is_global')?.value" />
                  </mat-form-field>
                </div>
                <p style="margin-top: 2%">Energy demand Equation (EDE)</p>
                <p style="margin-left: 5px">Test specific condition EDE values</p>
                <div class="group">
                  <div class="field-small">
                    <mat-form-field
                      class="full-width"
                      appearance="outline"
                      floatLabel="always"
                    >
                      <mat-label>A (constant)</mat-label>
                      <input type="number" matInput formControlName="ebg_factor_a" placeholder="Override value" />
                    </mat-form-field>
                  </div>
                  <div class="field-small">
                    <mat-form-field
                      class="full-width"
                      appearance="outline"
                      floatLabel="always"
                    >
                      <mat-label>B (linear)</mat-label>
                      <input type="number" matInput formControlName="ebg_factor_b" placeholder="Override value" />
                    </mat-form-field>
                  </div>
                  <div class="field-small">
                    <mat-form-field
                      class="full-width"
                      appearance="outline"
                      floatLabel="always"
                    >
                      <mat-label>D (cubic)</mat-label>
                      <input type="number" matInput formControlName="ebg_factor_d" placeholder="Override value" />
                    </mat-form-field>
                  </div>
                </div>

                <p *ngIf="condition.get('is_global')?.value" style="margin-left: 5px">Default condition EDE values</p>
                <div *ngIf="condition.get('is_global')?.value" class="group" style="margin-bottom: 2%">
                  <div class="field-small">
                    <mat-form-field
                      class="full-width"
                      appearance="outline"
                      floatLabel="always"
                    >
                      <mat-label>A (constant)</mat-label>
                      <input matInput readonly="true" value="automatic" />
                    </mat-form-field>
                  </div>
                  <div class="field-small">
                    <mat-form-field
                      class="full-width"
                      appearance="outline"
                      floatLabel="always"
                    >
                      <mat-label>B (linear)</mat-label>
                      <input matInput readonly="true" value="automatic" />
                    </mat-form-field>
                  </div>
                  <div class="field-small">
                    <mat-form-field
                      class="full-width"
                      appearance="outline"
                      floatLabel="always"
                    >
                      <mat-label>D (cubic)</mat-label>
                      <input matInput readonly="true" value="automatic" />
                    </mat-form-field>
                  </div>
                </div>

                <p>O2 per Watt Equation</p>
                <p style="margin-left: 5px">Test specific condition values</p>
                <div class="group">
                  <div class="field-small">
                    <mat-form-field
                      class="full-width"
                      appearance="outline"
                      floatLabel="always"
                    >
                      <mat-label>A (constant)</mat-label>
                      <input type="number" matInput formControlName="o2_per_watt_eq_a" placeholder="Override value" />
                    </mat-form-field>
                  </div>
                  <div class="field-small">
                    <mat-form-field
                      class="full-width"
                      appearance="outline"
                      floatLabel="always"
                    >
                      <mat-label>B (constant)</mat-label>
                      <input type="number" matInput formControlName="o2_per_watt_eq_b" placeholder="Override value" />
                    </mat-form-field>
                  </div>
                  <div class="field-small">
                    <mat-form-field
                      class="full-width"
                      appearance="outline"
                      floatLabel="always"
                    >
                      <mat-label>D (constant)</mat-label>
                      <input type="number" matInput formControlName="o2_per_watt_eq_d" placeholder="Override value" />
                    </mat-form-field>
                  </div>
                  <br />
                </div>
                <p *ngIf="condition.get('is_global')?.value" style="margin-left: 5px">Default condition values</p>
                <div *ngIf="condition.get('is_global')?.value" class="group">
                  <div class="field-small">
                    <mat-form-field
                      class="full-width"
                      appearance="outline"
                      floatLabel="always"
                    >
                      <mat-label>A (constant)</mat-label>
                      <input matInput readonly="true" value="automatic" />
                    </mat-form-field>
                  </div>
                  <div class="field-small">
                    <mat-form-field
                      class="full-width"
                      appearance="outline"
                      floatLabel="always"
                    >
                      <mat-label>B (constant)</mat-label>
                      <input matInput readonly="true" value="automatic" />
                    </mat-form-field>
                  </div>
                  <div class="field-small">
                    <mat-form-field
                      class="full-width"
                      appearance="outline"
                      floatLabel="always"
                    >
                      <mat-label>D (constant)</mat-label>
                      <input matInput readonly="true" value="automatic" />
                    </mat-form-field>
                  </div>
                  <br />
                </div>
              </ng-container>
            </div>
            <button
              mat-raised-button
              (click)="addCondition()"
              class="btn"
              type="button"
              color="primary"
            >
              Add Condition
            </button>
          </div>
        </div>

        <div class="setting__section">
          <h3 class="sub-title">
            <mat-icon
              *ngIf="!isShowTestSetting"
              (click)="isShowTestSetting = true"
            >keyboard_arrow_right</mat-icon
            >
            <mat-icon
              *ngIf="isShowTestSetting"
              (click)="isShowTestSetting = false"
            >keyboard_arrow_down</mat-icon
            >
            Test Environment
          </h3>
          <div class="content" *ngIf="isShowTestSetting">
            <mat-form-field
              class="full-width"
              appearance="outline"
              floatLabel="always"
            >
              <mat-label>Power meter</mat-label>
              <input matInput formControlName="power_meter" />
            </mat-form-field>
            <mat-form-field
              class="full-width"
              appearance="outline"
              floatLabel="always"
            >
              <mat-label>Lactate analyzer</mat-label>
              <input matInput formControlName="lactate_analyzer" />
            </mat-form-field>
            <mat-form-field
              class="full-width"
              appearance="outline"
              floatLabel="always"
            >
              <mat-label>Spirograph</mat-label>
              <input matInput formControlName="spirograph" />
            </mat-form-field>
            <mat-form-field
              class="full-width"
              appearance="outline"
              floatLabel="always"
            >
              <mat-label class="">Heart rate device</mat-label>
              <input matInput formControlName="heart_rate_device" />
            </mat-form-field>
            <mat-form-field
              class="full-width"
              appearance="outline"
              floatLabel="always"
            >
              <mat-label>Ergometer</mat-label>
              <input matInput formControlName="ergometer" />
            </mat-form-field>
            <mat-form-field
              class="full-width"
              appearance="outline"
              floatLabel="always"
            >
              <mat-label class="col-sm-2 control-label-content"
              >Temperature</mat-label
              >
              <input matInput formControlName="temperature" />
            </mat-form-field>
            <mat-form-field
              class="full-width"
              appearance="outline"
              floatLabel="always"
            >
              <mat-label class="col-sm-2 control-label-content"
              >Air Pressure</mat-label
              >
              <input matInput formControlName="air_pressure" />
            </mat-form-field>
            <mat-form-field
              class="full-width"
              appearance="outline"
              floatLabel="always"
            >
              <mat-label class="col-sm-2 control-label-content"
              >Humidity</mat-label
              >
              <input matInput formControlName="humidity" />
            </mat-form-field>
            <mat-form-field
              class="full-width"
              appearance="outline"
              floatLabel="always"
            >
              <mat-label class="col-sm-2 control-label-content"
              >Altitude</mat-label
              >
              <input matInput formControlName="altitude" />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="o-flex o-flex--justify-space-between" *ngIf="data.isManual || data.isVirtual">
        <button class="width-49-percent" mat-raised-button type="button" (click)="closeDialog()">Cancel</button>
        <button class="width-49-percent" mat-raised-button type="button" color="primary" (click)="save(true)">Process My Data</button>
      </div>
      <div class="o-flex o-flex--justify-space-between" *ngIf="data.isLactate || data.isPPD">
        <button class="width-49-percent" mat-raised-button type="button" (click)="closeDialog()">Cancel</button>
        <button class="width-49-percent" mat-raised-button type="button" color="primary" (click)="save(false)">Process My Data</button>
      </div>
    </div>
  </div>
</form>
